(function () {
    'use strict';

    angular
        .module('app')
        .controller('SignInController', SignInController);

    SignInController.$inject = ['$rootScope', '$routeParams', '$scope', '$location', '$window', 'UserService', '$translate', '$timeout', 'NotifyService', '$uibModal', 'BusinessService','SettingsService'];

    function SignInController($rootScope, $routeParams, $scope, $location, $window, UserService, $translate, $timeout, NotifyService, $uibModal, BusinessService, SettingsService) {
        $scope.CSRFToken = (Math.random() * 10000).toString(36);
        $scope.isPrimeFuel = appConfig.platformParams.main_site.en === 'prime-fuel.com';
        $scope.model = {
            login: '',
            password: '',
            newPassword: '',
            confirmNewPassword: '',
            pincode: '',
            phone: '',
            terms: false
        };

        $scope.user = {};
        $scope.state = {
            showRegisterButtons: true
        };

        $scope.messages = {};
        $scope.messages.error = '';
        $scope.dataLoading = false;
        $scope.loginAsPhone = false;
        $scope.isSendedPin = false;

        $scope.pincodeRequests = 0;

        $scope.phoneValid = false;
        $scope.mailValid = false;
        $scope.passwordMatch = false;
        $scope.showChangePasswords = false;

        $scope.isForgotPassword = false;
        $scope.restorePasswordByPhone = false;
        $scope.restorePasswordByEmail = false;
        $scope.restorePasswrodAddNewPhone = false;
        $scope.restorePasswrodAddNewEmail = false;
        $scope.showlicenseAgreements = false;


        $scope.loginBySpecialLink = false;
        $scope.isDirectLogin = true;


        $scope.isGLO = appConfig.platformParams.main_site.en === 'myglo.com.ua' || appConfig.platformParams.main_site.en === 'testclient.myglo.com.ua';
        $scope.getLegalLinks = function () {
            SettingsService.GetLegalLinks(function (success, response) {
                if (success) {
                    $scope.terms_of_service_url = response.terms_of_service_url;
                    $scope.privacy_policy_url = response.privacy_policy_url;
                    $scope.terms_of_service_business_url = response.terms_of_service_business_url;
                }
            })
        };

        initController();
        validateHost();
        $scope.getLegalLinks();
        function autofillPhone() {
            if ($location.$$search && $location.$$search.user) {
                $scope.model.login ='+' +$location.$$search.user;
                $scope.model.phone='+'
                $scope.loginBySpecialLink = true;
                $scope.restorePasswordByPhone = true;
                $scope.showChangePasswords = false;
                $scope.restorePasswrodAddNewPhone = false;
                $scope.isForgotPassword = true;
                $scope.phoneValid = true;
            }

            if ($location.$$search && $location.$$search.login && $location.$$search.admin) {
                $scope.model.login = $location.$$search.login;
                if($scope.isValidEmail($location.$$search.admin)) {
                    $scope.model.email = $location.$$search.admin;
                    $scope.loginBySpecialLink = true;
                    $scope.restorePasswordByPhone = false;
                    $scope.restorePasswordByEmail = true;
                    $scope.showChangePasswords = false;
                    $scope.restorePasswrodAddNewPhone = false;
                    $scope.isForgotPassword = true;
                    $scope.phoneValid = false;
                    $scope.mailValid = true;
                } else {
                    $scope.model.phone = $location.$$search.admin;
                    $scope.loginBySpecialLink = true;
                    $scope.restorePasswordByPhone = true;
                    $scope.showChangePasswords = false;
                    $scope.restorePasswrodAddNewPhone = false;
                    $scope.isForgotPassword = true;
                    $scope.phoneValid = true;
                }
            }
            if ($location.$$search && $location.$$search.setPassword) {
                $scope.model.login = $location.$$search.setPassword;
                $scope.restorePasswordByPhone = false;
                $scope.restorePasswordByEmail = true;
                $scope.showChangePasswords = false;
                $scope.restorePasswrodAddNewPhone = false;
                $scope.isForgotPassword = true;
                $scope.mailValid = true;


            }
            if ($location.$$search && $location.$$search.userIn) {
                $scope.user = $location.$$search.userIn;
                $scope.restorePasswordByPhone = false;
                $scope.restorePasswordByEmail = true;
                $scope.showChangePasswords = false;
                $scope.restorePasswrodAddNewPhone = false;
                $scope.isForgotPassword = true;
                $scope.mailValid = true;
                $scope.showlicenseAgreements = true;
                $scope.isDirectLogin = true;


            }
        }


        function validateHost() {
            var host = $location.host();
            $scope.state.showRegisterButtons = host.includes('incust') || host.includes('localhost');

            if ($location.$$search && $location.$$search.user) {
                $scope.model.login = '+';
                $scope.loginAsPhone = true;
            }
        }

        $scope.loginAsPhoneClick = function () {
            $scope.model.login = '+';
            $scope.loginAsPhone = true;
        }

        $scope.loginAsEmailClick = function () {
            $scope.model.login = '';
            $scope.loginAsPhone = false;
        }

        function initController() {
            $scope.currentLang = $translate.use();



            var qp = $location.search();
            if (qp) {
                if (qp['message']) {
                    $scope.messages.error = qp['message'];
                    $location.search('message', null);
                }
                if (qp['p'] && qp['su']) {
                    $scope.model.login = qp['p'];
                    $location.search({p: null, su: null});

                    $scope.phoneValid = true;
                    $scope.loginAsPhone = true;
                    $scope.state.showRegisterButtons = false;

                    var post_data = {
                        login: $scope.model.login
                    };

                    UserService.RequestLoginPinv2(post_data, function (success, response) {
                        if (success) {
                            $scope.pincodeRequests++;
                            $scope.isSendedPin = true;
                        } else {
                            var inline_error = response.code == 1 || response.code == 2 || response.code == 4 || response.code == 5;
                            if (inline_error) {
                                $scope.messages.error = response.message;
                            }
                        }
                        $scope.dataLoading = false;
                    });
                }

            }
        }

        $scope.isValidPhoneNumber = function (phoneNumber) {
            return isPhoneValid(phoneNumber)
        }
        $scope.isValidEmail = function (email) {
            const mail_regex = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/);
            return mail_regex.test(email)
        }
        $scope.onPasswordsChange = function () {
            $scope.passwordMatch = $scope.model.newPassword === $scope.model.confirmNewPassword;
        }
        /**
         * Event recive when input login is changes
         */

        $scope.onChangeLogin = function () {
            if(!$scope.loginAsPhone) {
                if ($scope.isValidEmail($scope.model.login)) {
                    $scope.mailValid = true;
                    $scope.form.login.$invalid = false;
                } else {
                    $scope.mailValid = false;
                    $scope.form.login.$invalid = true
                }
            } else {
                if ($scope.isValidPhoneNumber($scope.model.login)) {
                    $scope.phoneValid = true;
                    $scope.form.login.$invalid = false;
                } else {
                    $scope.phoneValid = false;
                    $scope.form.login.$invalid = true
                }
            }
        }

        $scope.onChangeEmail = function () {
            if ($scope.isValidEmail($scope.model.email)) {
                $scope.mailValid = true;
                $scope.form.email.$invalid = false;
            } else {
                $scope.mailValid = false;
                $scope.form.email.$invalid = true
            }

        }

        $scope.onChangePhone = function () {
            if ($scope.isValidPhoneNumber($scope.model.phone)) {
                $scope.phoneValid = true;
                $scope.form.phone.$invalid = false;
            } else {
                $scope.phoneValid = false;
                $scope.form.phone.$invalid = true
            }
        }

        /**
         * Send requst for gets pin-code
         */

        $scope.requestPin = function () {

            $scope.dataLoading = true;
            $scope.resentPincodeTimeout = false;
            $scope.isSendedPin = false;
            console.info('resend pin');

            const post_data = angular.copy($scope.model);
            $scope.model.pincode = ''
            post_data.password = $scope.isSendedPin ? post_data.pincode : $scope.model.password;
            var qp = $location.search();
            for (var key in qp) {
                post_data[key] = qp[key];
            }

            if (post_data.user) {
                var temp_login_value = post_data.login;
                post_data.admin = temp_login_value.substring(1);
                delete post_data.user;
            }
            // here is admin catching

            UserService.RequestLoginPinv2(post_data, function (success, response) {
                if (success) {
                    $scope.pincodeRequests++;
                    $scope.isSendedPin = true;
                } else {
                    var inline_error = response.code == 1 || response.code == 2 || response.code == 4 || response.code == 5;
                    if (inline_error) {
                        $scope.messages.error = response.message;
                    }
                }
                $scope.dataLoading = false;
            });


        }
        $scope.requestPhonePin = function () {
            $scope.dataLoading = true;
            const post_data = {
                value: $scope.model.login,
                pin: ''
            }

            UserService.RequestPhoneChangePre(post_data, function (success, response) {
                if (success) {
                    if (response.code === 0 && !response.phone) {
                        $scope.pincodeRequests++;
                    }

                } else {
                    NotifyService.Error(response.message, false)

                }
                $scope.dataLoading = false;

            });
        }
        $scope.requestEmailPin = function () {
            $scope.dataLoading = true;
            const post_data = {
                value: $scope.model.login,
                pin: ''
            }

            UserService.RequestEmailChangePre(post_data, function (success, response) {
                if (success) {
                    if (response.code === 0 && !response.phone) {
                        $scope.pincodeRequests++;
                    }

                } else {
                    NotifyService.Error(response.message, false)

                }
                $scope.dataLoading = false;

            });
        }

        /**
         * open modal to redirect to signup
         */
        function goToSignUpModal(isPhone) {
            var modalInstance = $uibModal.open({
                animation: true,
                keyboard: false,
                size: 'sm',
                controllerAs: 'popup',
                templateUrl: 'app/templates/modal.auth.is.by.phone.tpl.html',
                controller: function ($scope, $uibModalInstance) {
                    const popup = this;
                    popup.isPone = isPhone;

                    popup.ok = function () {
                        $uibModalInstance.close();

                    };
                }
            });

            modalInstance.closed.then(() => {
                $scope.redirectToSignUp()
            })
        }

        /**
         * reset all steps in order to be able to login
         */
        $scope.resetAll = function () {
            $scope.restorePasswordByEmail = false;
            $scope.restorePasswordByPhone = false;
            $scope.restorePasswrodAddNewEmail = false;
            $scope.restorePasswrodAddNewPhone = false;
            $scope.showChangePasswords = false;
            $scope.isForgotPassword = false;
        }

        function showAddNewPhone() {
            $scope.restorePasswordByEmail = false;
            $scope.restorePasswordByPhone = true;
            $scope.restorePasswrodAddNewEmail = false;
            $scope.restorePasswrodAddNewPhone = true;
            $scope.showChangePasswords = false;
            $scope.isForgotPassword = true;
            $scope.hasUserPhone = false;
        }

        function loginUserToPortal() {
            UserService._storeUserPublic($scope.user);
            $rootScope.$broadcast('user-login');
            if ($rootScope.USER.language) {
                $rootScope.LANG = $rootScope.USER.language;
                $translate.use($rootScope.USER.language);
            }
            //$analytics.eventTrack('Sing In', {  category: 'Login', label: 'Business panel' });
            $window.ga('send', 'event', 'Business panel', 'Sing In', 'Login');

            var query = $location.search();
            var pathTo = query.redirect ? query.redirect : '/';
            $location.path(pathTo);

            // Remove query parameter
            $location.search('redirect', null);
            $scope.inlineMessage = undefined;
        }

        function getChatUrl(){
            if($scope.isPrimeFuel){
                return  'https://prime-fuel.com/?HelpCrunchOpenChat=1'
            }else{
               return  'https://'+ appConfig.platformParams.main_site[$scope.currentLang]+'/'+$scope.currentLang +'/chat'
            }
        }
        function getBusinessAndLogIn() {
            BusinessService.Get(function (success, data) {
                if (success && data) {
                    loginUserToPortal();
                    if(data.notify_balance_less_than_value_wo_credit_limit) {
                        if(
                            data.expenses_average_day_amount &&
                            data.status.account_balance > 0 &&
                            data.expenses_average_day_amount * 3 > data.status.account_balance
                        ) {
                            showTopUpAlert();
                        }
                    } else {
                        if(
                            data.expenses_average_day_amount &&
                            data.status.account_balance + data.status.credit_limit > 0 &&
                            data.expenses_average_day_amount * 3 > data.status.account_balance + data.status.credit_limit
                        ) {
                            showTopUpAlert();
                        }
                    }

                } else {
                    if(data.code && data.code === 36){

                        $translate('app#online_support_start_chat', {url: getChatUrl()}).then(function(translations) {
                            $scope.messages.error = data.message + '<div>' + translations + '</div>';

                        });

                        $scope.restorePasswordByEmail = false;
                        $scope.restorePasswordByPhone = false;
                        $scope.restorePasswordByPhone = false;
                        $scope.restorePasswrodAddNewEmail = false;
                        $scope.restorePasswrodAddNewPhone = false;
                        $scope.showChangePasswords = false;
                        $scope.isForgotPassword = false;
                    }else {
                    // show accept license agreements
                    $scope.showlicenseAgreements = true;
                    $scope.restorePasswordByEmail = true;
                    $scope.restorePasswordByPhone = false;
                    $scope.restorePasswrodAddNewEmail = false;
                    $scope.restorePasswrodAddNewPhone = false;
                    $scope.showChangePasswords = false;
                    $scope.isForgotPassword = true;
                    }

                }

            })
        }

        function showTopUpAlert() {
            $uibModal.open({
                animation: true,
                keyboard: false,
                size: 'md',
                controllerAs: 'popup',
                templateUrl: 'app/templates/modal.top-up-account.html',
                controller: function ($scope, $uibModalInstance) {
                    const popup = this;

                    popup.closeModal = function () {
                        $uibModalInstance.close();
                    };

                    popup.goToTopUp = function () {
                        var p = $location.path('/payment');
                        var currentPath = $location.path();
                        if (currentPath && currentPath !== p) {
                            p.search({redirect: currentPath});
                        }
                        $uibModalInstance.close();
                    };
                }
            });
        }

        $scope.loginSuccessHandler = function (success, response) {
            if (success) {
                $scope.user = response.user;
                //  check if the user has registered phone number
                if ($scope.user.phone && $scope.user.phone !== '') {
                //check if the  user has registered  business
                    getBusinessAndLogIn();
                } else if($scope.loginBySpecialLink){
                    getBusinessAndLogIn();
                } else {
                    //show phone add
                    showAddNewPhone()
                }


            } else {
                var inline_error = response.code == 1 || response.code == 2 || response.code == 4 || response.code == 5;
                if (inline_error) {
                    $scope.messages.error = response.message;
                }
            }
            $scope.dataLoading = false;
        }

        $scope.acceptAgreements = function () {
            if ($scope.model.terms) {
                $scope.form.terms.$dirty = true;
                $scope.form.terms.$error.required = false;
                loginUserToPortal()
            } else {
                $scope.form.terms.$dirty = true;
                $scope.form.terms.$error.required = true;
            }
        }

        $scope.skipPhoneNumber = function () {
            getBusinessAndLogIn()
        }
        /**
         * Submit login form
         */
        $scope.Login = function () {
            $scope.dataLoading = true;
            if(!$scope.loginAsPhone) {
                if ($scope.mailValid && $scope.model.password !== '') {
                    const post_data = angular.copy($scope.model);
                    $scope.isDirectLogin = true;
                    UserService.Loginv2(post_data, $scope.loginSuccessHandler);
                } else {
                    $scope.form.login.$dirty = true;
                    $scope.dataLoading = false;
                    $scope.messages.error = '';
                }
            } else {
                if ($scope.phoneValid && $scope.model.password !== '') {
                    const post_data = angular.copy($scope.model);
                    $scope.isDirectLogin = true;
                    UserService.Loginv2(post_data, $scope.loginSuccessHandler);
                } else {
                    $scope.form.login.$dirty = true;
                    $scope.dataLoading = false;
                    $scope.messages.error = '';
                }
            }
        };
        /**
         * restore access by email, by phone number
         */
        $scope.getTokenByEmail = function () {

            function handleResult(success, response) {
                if (success) {
                    console.log("success ", response)
                    $scope.resentPincodeTimeout = true;
                    $scope.pincodeRequests++;
                    if (response.code === 0 && !response.user) {
                        $scope.isSendedPin = true
                        NotifyService.Success(response.message, false);

                    } else if (response.user && response.token) {
                        if ($scope.loginBySpecialLink) {
                            $scope.loginSuccessHandler(success, response)
                        } else {
                            $scope.showChangePasswords = true;
                            $scope.resentPincodeTimeout = false;
                            $scope.pincodeRequests = 0;
                            $scope.isSendedPin = false;
                            $scope.model.pincode = ''
                        }
                    }

                } else {
                    if (response.code == 1 || response.code == 4 || response.code == 5) {
                        $scope.messages.error = response.message;
                    } else if (response.code == 2) {
                        // show modal
                        goToSignUpModal(false)
                    }
                }
                $scope.dataLoading = false;
            }

            $scope.dataLoading = true;

            if($scope.loginBySpecialLink) {
                if ($scope.mailValid) {
                    const post_data ={
                        login: $scope.model.login,
                        password: $scope.isSendedPin ? $scope.model.pincode : $scope.model.password,
                        pincode: $scope.model.pincode,
                        admin: $scope.model.email
                    }
                    UserService.Loginv2(post_data, handleResult);
                } else {
                    $scope.form.email.$dirty = true;
                    $scope.dataLoading = false;
                    $scope.messages.error = '';
                }
            } else {
                if ($scope.mailValid) {
                    $scope.model.password = ''
                    const post_data = {
                        confirmNewPassword : '',
                        login: $scope.model.email,
                        newPassword: $scope.model.newPassword,
                        password: $scope.model.password,
                        phone: '',
                        pincode: $scope.model.pincode,
                    };
                    post_data.password = $scope.isSendedPin ? post_data.pincode : $scope.model.password;
                    UserService.Loginv2(post_data, handleResult);
                } else {
                    $scope.form.login.$dirty = true;
                    $scope.dataLoading = false;
                    $scope.messages.error = '';
                }
            }
        }
        $scope.getTokenByPhone = function () {

            function handleResult(success, response) {
                if (success) {
                    console.log("success ", response)
                    $scope.resentPincodeTimeout = true;
                    $scope.pincodeRequests++;
                    if (response.code === 0 && !response.user) {
                        $scope.isSendedPin = true
                        NotifyService.Success(response.message, false);

                    } else if (response.user && response.token) {
                        $scope.resentPincodeTimeout = false;
                        $scope.pincodeRequests = 0;
                        if ($scope.loginBySpecialLink) {
                            $scope.loginSuccessHandler(success, response)
                        } else {
                            if (response.user.login) {
                                $scope.showChangePasswords = true;
                                $scope.restorePasswordByEmail = true;
                                $scope.restorePasswordByPhone = false;
                                $scope.isSendedPin = false;
                                $scope.model.pincode = ''
                                $scope.model.login = response.user.login
                            } else {
                                $scope.restorePasswordByPhone = false;
                                $scope.restorePasswordByEmail = true;
                                $scope.restorePasswrodAddNewEmail = true;
                                $scope.isSendedPin = false;
                                $scope.model.pincode = ''
                                $scope.model.login = ''
                            }
                        }


                    }

                } else {

                    if (response.code == 1 || response.code == 4 || response.code == 5) {
                        $scope.messages.error = response.message;
                    } else if (response.code == 2) {
                        // show modal
                        goToSignUpModal(true)
                    }
                }
                $scope.dataLoading = false;
            }

            $scope.dataLoading = true;
            if ($scope.phoneValid) {
                $scope.model.password = ''
                const post_data ={
                    login: $scope.model.phone,
                    password: $scope.isSendedPin ? $scope.model.pincode : $scope.model.password,
                    pincode: $scope.model.pincode
                }
                if ($scope.loginBySpecialLink) {
                    post_data.admin =  $scope.model.phone;
                    post_data.login = $scope.model.login;
                }
                UserService.Loginv2(post_data, handleResult);
            } else {
                $scope.form.phone.$dirty = true;
                $scope.dataLoading = false;
                $scope.messages.error = '';
            }
        }
        $scope.saveNewPassword = function () {
            if ($scope.model.newPassword !== '' && $scope.model.confirmNewPassword !== '' && $scope.passwordMatch) {
                $scope.dataLoading = true
                var post_data = {
                    password: $scope.model.newPassword,
                }
                UserService.ChangePassword(post_data, function (success, response) {
                    if (success) {
                        $scope.isDirectLogin = false;
                        if (response.user && response.user.phone) {
                            $scope.loginSuccessHandler(success, response)
                        } else {
                            $scope.showChangePasswords = false
                            $scope.restorePasswrodAddNewPhone = true
                            $scope.restorePasswordByPhone = true
                            $scope.restorePasswordByEmail = false
                            $scope.resentPincodeTimeout = true;
                            $scope.model.login = '+';
                            $scope.dataLoading = false;
                        }

                    }else{
                        $scope.dataLoading = false;
                    }

                });
            }
        };
        $scope.saveNewPhone = function () {

            $scope.dataLoading = true;
            if ($scope.phoneValid) {

                const post_data = {
                    value: $scope.model.phone,
                    pin: $scope.model.pincode
                }
                UserService.RequestPhoneChangePre(post_data, function (success, response) {
                    if (success) {
                        if (response.code === 0 && !response.phone) {
                            $scope.isSendedPin = true


                        } else {
                            const res = {
                                user: response
                            }
                            $scope.loginSuccessHandler(success, res)

                        }
                        $scope.dataLoading = false

                    } else {
                        NotifyService.Error(response.message, false)

                    }


                });
            } else {
                $scope.form.phone.$dirty = true;
                $scope.dataLoading = false;
                $scope.messages.error = '';
            }
        }
        $scope.saveNewEmail = function () {

            $scope.dataLoading = true;
            if ($scope.mailValid) {

                const post_data = {
                    value: $scope.model.login,
                    pin: $scope.model.pincode
                }

                UserService.RequestEmailChangePre(post_data, function (success, response) {
                    $scope.dataLoading = false
                    if (success) {
                        if (response.code === 0 && !response.phone) {
                            $scope.isSendedPin = true
                            $scope.resentPincodeTimeout = true;

                        } else if (response.login) {

                            $scope.showChangePasswords = true;
                            $scope.restorePasswordByEmail = true;
                            $scope.restorePasswordByPhone = false;
                            $scope.restorePasswrodAddNewEmail = false;
                            $scope.restorePasswrodAddNewPhone = false;
                            $scope.isSendedPin = false;
                            $scope.model.pincode = ''
                        }


                    } else {
                        if(response.code !== 26){
                        NotifyService.Error(response.message, false)
                        }

                    }


                });
            } else {
                $scope.form.login.$dirty = true;
                $scope.dataLoading = false;
                $scope.messages.error = '';
            }
        }
        $scope.onMyGLOSignIn = function () {
            $scope.model.login = '+';
            $scope.loginAsPhone = true;
        };

        $scope.$watchCollection('[model.login, model.password, model.pincode]', function (newValues, oldValues) {
            //$scope.inlineMessage = '';
        });


        $scope.onRestoreByPhoneClick = function () {
            $scope.restorePasswordByPhone = true;
            $scope.model.phone = '+'
            $scope.model.login = ''
            $scope.model.password = ''

        }
        $scope.onRestoreByEmailClick = function () {
            $scope.restorePasswordByEmail = true;
            $scope.model.login = ''
        }

        $scope.onPasswordForgotClick = function () {
            $scope.isForgotPassword = true;
            $scope.messages.error = ''
        }

        $scope.onContactMeClick = function () {
            UserService.SendToSupport($scope.model, 'PIN-CODE NOT RECEIVED', function (success, response) {
                if (success) {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        keyboard: true,
                        size: 'sm',
                        templateUrl: 'app/templates/modal.auth.support.tpl.html',
                        controller: function ($scope, $uibModalInstance) {
                            $scope.onReplyOK = function () {
                                $uibModalInstance.dismiss('cancel');
                            };
                        }
                    });
                }
            });
        }
        autofillPhone();

        /**
         * Redirect to "Sign up" page with "redirect" parameter for follow back after registration
         */
        $scope.redirectToSignUp = function () {
            var currentPath = $location.path();
            var p = $location.path('/signup');

            if (currentPath && currentPath != p) {
                p.search({redirect: $routeParams['redirect'] ? $routeParams['redirect'] : undefined});
            }
        };

    }
})();
